// extracted by css-extract-rspack-plugin
export default {"root":"H61P2N","toggle":"_egRAB","count":"rPVjUO","menu":"OfXKH8","arrow":"OES0UK"};